import { mapState } from 'vuex';
import { _checkValidityDate } from '@/utils/_function.js';

export default {
  name: 'AlertNotification',
  props: {
    type: {
      type: String
    }
  },
  computed: {
    ...mapState({
      expiringPowersOfAttorneyList: state => state.expiringPowersOfAttorneyList
    })
  },
  methods: {
    closeAlertNotification() {
      this.$store.dispatch('toggleAlertNotification', { isClose: true, type: this.type });
    },
    checkValidity(dateTo) {
      return _checkValidityDate(dateTo);
    },

    checkExpiring(expiringPowersOfAttorneyList) {
      if (!expiringPowersOfAttorneyList.length) return;

      return expiringPowersOfAttorneyList.some(elem => {
        return _checkValidityDate(elem.endedAt, false) <= 10;
      });
    }
  }
};
